module.exports = __webpack_public_path__ + "img/01.8571ea57.png";